import { useCallback, useState } from "react";
import { sanitizeCategories, type PlaceCategoryId } from "../../../shared/categories";

const KEY = "hermes.categories";

function read(): PlaceCategoryId[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? sanitizeCategories(JSON.parse(raw)) : [];
  } catch {
    return [];
  }
}

/** Categorías de actividad marcadas; se recuerdan entre pantallas y visitas (Planes, Plan sorpresa y Ruta comparten el filtro). */
export function useCategories(): [PlaceCategoryId[], (next: PlaceCategoryId[]) => void] {
  const [selected, setSelected] = useState<PlaceCategoryId[]>(read);
  const update = useCallback((next: PlaceCategoryId[]) => {
    const clean = sanitizeCategories(next);
    setSelected(clean);
    try {
      localStorage.setItem(KEY, JSON.stringify(clean));
    } catch {
      /* sin almacenamiento: solo en memoria */
    }
  }, []);
  return [selected, update];
}
